/* Tab switcher for the PDP "More of this style" / "You may also like" section
 * (sections/afroyla-pdp-style-tabs.liquid). Plain IIFE + delegated listener,
 * matching the other afroyla-*.js modules. */
(function () {
  'use strict';

  if (window.__aflStyleTabsInit) return;
  window.__aflStyleTabsInit = true;

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-afl-styletab]');
    if (!tab) return;
    var root = tab.closest('[data-afl-styletabs]');
    if (!root) return;
    var key = tab.getAttribute('data-afl-styletab');

    root.querySelectorAll('[data-afl-styletab]').forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-afl-stylepanel]').forEach(function (p) {
      if (p.getAttribute('data-afl-stylepanel') === key) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  });
})();
